import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DeviderLine from "../../../../../../ui/InfoDrawer/components/DeviderLine";
import InfoField from "../../../../../../ui/InfoDrawer/components/InfoField";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import UploadDropzone from "../../../../../../ui/FileIUpload/UploadDropzone";
import DataSelect from "../../../../../../ui/DataSelect";

const defaultData = {
  name: "",
  code: "",
  description: "",
  statusId: 0,
  title: "",
  instruction: "",
  thanxMessage: "",
  isCommon: false,
  logo: null
};

const quizstates = [
  {id: 0, name: "Неактивный"},
  {id: 1, name: "Активный"}
];

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  dropzoneWraper: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  dropZoneButtonArea: {
    width: 75,
    height: 35,
    zIndex: 1000,
    position: "absolute",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  iconButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
});

const MainInfo = ({ disabled, onFormChange,
                    initialData, classes, editmode,
                  deleteQuizLogo, updateQuizLogo}) => {
  const [data, setData] = React.useState(defaultData);
  const {
    name,
    code,
    description,
    statusId,
    title,
    instruction,
    thanxMessage,
    isCommon,
    logo
  } = data;

  useEffect(() => {
    if (initialData) {
      setData(initialData);
    }
  }, [initialData]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  const UploadLogo = files => {
    if (files && files.length > 0) {
      updateQuizLogo(files[0]);
    }
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Основные параметры</Typography>
      <Grid container spacing={1} className={classes.mainGrid}>
        <Grid item xs={6} sm={4} md={3}>
          <TextField
            required
            value={code || ''}
            onChange={e => onChange("code", e.target.value)}
            label="Код"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={6} sm={8} md={9}>
          <TextField
            required
            value={name || ''}
            onChange={e => onChange("name", e.target.value)}
            label="Название"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <DataSelect
            value={statusId}
            onChange={value => onChange("statusId", value.id)}
            label="Статус"
            dataSource={quizstates}
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={6} sm={8} md={9}>
          <TextField
            multirow="true"
            value={description || ''}
            onChange={e => onChange("description", e.target.value)}
            label="Описание"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
      </Grid>
      <DeviderLine/>

      <Typography className={classes.heading}>Заголовок и инструкция</Typography>
      <TextField
        value={title || ''}
        onChange={e => onChange("title", e.target.value)}
        label="Заголовок"
        disabled={disabled}
        readOnly={!editmode}
      />
      <TextField
        multirow="true"
        value={instruction || ''}
        onChange={e => onChange("instruction", e.target.value)}
        label="Инструкция"
        disabled={disabled}
        readOnly={!editmode}
      />
      <DeviderLine/>

      <Typography className={classes.heading}>Благодарность за участие</Typography>

      <TextField
        multirow="true"
        value={thanxMessage || ''}
        onChange={e => onChange("thanxMessage", e.target.value)}
        label="Сообщение участникам опроса"
        disabled={disabled}
        readOnly={!editmode}
      />

      <DeviderLine/>

      <div>
        <InfoField name="Изображение карточки" />
        <div className={classes.dropzoneWraper}>
          <div className={classes.dropZoneButtonArea}>
            <Tooltip title="Удалить" placement="top">
              <IconButton
                classes={{ root: classes.iconButton }}
                onClick={deleteQuizLogo}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </div>
          <UploadDropzone
            type="card"
            fileId={logo}
            accept={[".jpg", ".jpeg", ".png"]}
            onDrop={image => {
              UploadLogo(image);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(MainInfo);
